import { create } from "zustand";

interface ThemeState {
  isDark: boolean;
  // 保留接口以防未来需要扩展
  initTheme: () => void;
}

export const useThemeStore = create<ThemeState>((_set) => ({
  isDark: true, // 固定为暗色模式

  initTheme: () => {
    // 确保应用始终使用暗色模式
    document.documentElement.classList.add("dark");
    document.body.style.backgroundColor = "#05010f";
  },
}));
